import { GallerySceneLocationType } from '../CommonTypes';

// Converts SVG circle (cx, cy) coordinates into yaw and pitch using the viewBox
const convertCircleToYawAndPitch = (cx: number, cy: number, viewBox: string): { yaw: number; pitch: number } => {
  const [minX, minY, width, height] = viewBox.split(' ').map(Number);

  const relativeX = (cx - minX) / width; // 0 to 1
  const relativeY = (cy - minY) / height; // 0 to 1

  const yaw = -relativeX * 360 - 180; // -180 to 180
  const pitch = 90 - relativeY * 180; // 90 to -90

  return { yaw, pitch };
};

// Fetch viewBox and circle-based GallerySceneLocationType positions from an SVG
export const fetchGallerySceneLocationSVG = async (
  svgUrl: string | undefined
): Promise<{ viewBox: string; paths: GallerySceneLocationType[] }> => {
  try {
    if (!svgUrl) return { viewBox: '', paths: [] };

    const response = await fetch(svgUrl);
    if (!response.ok) throw new Error('Failed to load SVG');

    const svgText = await response.text();
    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');

    const svgElement = svgDoc.querySelector('svg');
    const viewBox = svgElement?.getAttribute('viewBox') || '';
    if (!viewBox) return { viewBox: '', paths: [] };

    const paths: GallerySceneLocationType[] = Array.from(svgDoc.querySelectorAll('circle')).map(element => {
      const cx = parseFloat(element.getAttribute('cx') || '0');
      const cy = parseFloat(element.getAttribute('cy') || '0');

      const { yaw, pitch } = convertCircleToYawAndPitch(cx, cy, viewBox);

      return {
        id: element.getAttribute('id') || '',
        ref_id: element.getAttribute('data-ref_id') || '',
        type: element.getAttribute('data-type') || 'view',
        yaw,
        pitch,
      } as GallerySceneLocationType;
    });

    return { viewBox, paths };
  } catch (error) {
    console.error('Error loading SVG:', error);
    return { viewBox: '', paths: [] };
  }
};
